var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "br-map-panel" }, [
    _c("div", { staticClass: "br-map-wrap" }, [
      _c(
        "svg",
        {
          ref: "svg",
          staticClass: "br-map",
          class: { "is-checking": _vm.checking },
          attrs: { viewBox: _vm.viewBox, xmlns: "http://www.w3.org/2000/svg" },
        },
        [
          _vm._l(_vm.locations, function (loc) {
            return _c("path", {
              key: loc.id,
              ref: "path-" + loc.id,
              refInFor: true,
              staticClass: "state",
              class: _vm.stateCls(loc.id),
              attrs: { d: loc.path, fill: _vm.fillOf(loc.id) },
              on: {
                mouseenter: function ($event) {
                  return _vm.showTip(loc.id)
                },
                mousemove: function ($event) {
                  return _vm.moveTip($event)
                },
                mouseleave: _vm.hideTip,
                click: function ($event) {
                  return _vm.handleClick(loc.id)
                },
              },
            })
          }),
          _vm._l(_vm.labels, function (l) {
            return _c(
              "text",
              {
                key: "label-" + l.uf,
                staticClass: "state-label",
                class: l.cls,
                attrs: {
                  x: l.x,
                  y: l.y,
                  "font-size": l.size,
                  "text-anchor": "middle",
                },
              },
              [_vm._v(_vm._s(l.uf))]
            )
          }),
        ],
        2
      ),
      _c(
        "aside",
        { staticClass: "map-legend" },
        [
          _vm._m(0),
          _vm._l(_vm.legendItems, function (item) {
            return _c("div", { key: item.key, staticClass: "lg-item" }, [
              _c("span", {
                staticClass: "lg-dot",
                class: { "lg-expire-dot": item.key === "expire" },
                style: item.dotStyle,
              }),
              _c("span", { staticClass: "lg-text" }, [
                _c("span", { staticClass: "lg-zh" }, [_vm._v(_vm._s(item.zh))]),
                _c("span", { staticClass: "lg-pt" }, [_vm._v(_vm._s(item.pt))]),
              ]),
              _c(
                "span",
                {
                  staticClass: "lg-count",
                  class: { "lg-expire-count": item.key === "expire" },
                },
                [_vm._v(_vm._s(item.count))]
              ),
            ])
          }),
        ],
        2
      ),
    ]),
    _c("div", { staticClass: "map-footnote" }, [
      _c("div", [
        _vm._v(" 实际服务 "),
        _c("b", [_vm._v(_vm._s(_vm.states.length))]),
        _vm._v(" 州 · 监控 "),
        _c("b", [_vm._v(_vm._s(_vm.states.length))]),
        _vm._v(" 州 "),
        _c("span", { staticClass: "fn-pt" }, [
          _vm._v(
            " Cobertura real: " +
              _vm._s(_vm.states.length) +
              " estados · monitorados: " +
              _vm._s(_vm.states.length) +
              " estados "
          ),
        ]),
      ]),
      _c("div", { staticClass: "fn-note" }, [
        _vm._v(
          " （北部 " +
            _vm._s(_vm.unmonitoredNum) +
            " 州：" +
            _vm._s(_vm.northText) +
            " 业务未对外报价，灰色未覆盖） "
        ),
        _c("span", { staticClass: "fn-pt" }, [
          _vm._v(
            "(" +
              _vm._s(_vm.unmonitoredNum) +
              " estados do Norte: " +
              _vm._s(_vm.northText) +
              " sem tarifas publicadas; cinza = não coberto)"
          ),
        ]),
      ]),
      _vm._m(1),
    ]),
    _c(
      "div",
      {
        staticClass: "map-tooltip",
        class: { show: _vm.tip.show },
        style: { left: _vm.tip.x + "px", top: _vm.tip.y + "px" },
      },
      [
        _c("div", { staticClass: "tip-uf" }, [
          _vm._v(" " + _vm._s(_vm.tip.uf)),
          _vm.tip.companyName
            ? _c("span", { staticClass: "tip-co" }, [
                _vm._v(" · " + _vm._s(_vm.tip.companyName)),
              ])
            : _vm._e(),
          _vm.tip.ufPt
            ? _c("span", { staticClass: "tip-pt tip-uf-pt" }, [
                _vm._v("/ " + _vm._s(_vm.tip.ufPt)),
              ])
            : _vm._e(),
        ]),
        _vm._l(_vm.tip.rows, function (row) {
          return _c("div", { key: row.key, staticClass: "tip-row" }, [
            _c("span", { staticClass: "tip-k" }, [
              _vm._v(_vm._s(row.k)),
              _c("span", { staticClass: "tip-pt" }, [
                _vm._v(" / " + _vm._s(row.kPt) + ":"),
              ]),
            ]),
            _c("b", { style: { color: row.color } }, [
              _vm._v(_vm._s(row.v)),
              row.vPt
                ? _c("span", { staticClass: "tip-pt" }, [
                    _vm._v(" / " + _vm._s(row.vPt)),
                  ])
                : _vm._e(),
            ]),
          ])
        }),
        _vm.tip.reason
          ? _c("div", { staticClass: "tip-reason" }, [
              _vm._v(" " + _vm._s(_vm.tip.reason)),
              _c("span", { staticClass: "tip-pt" }, [
                _vm._v(" / " + _vm._s(_vm.tip.reasonPt)),
              ]),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("span", [_vm._v("图例 · 27 州")]),
      _c("span", { staticClass: "lg-pt" }, [_vm._v("Legenda · 27 estados")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fn-tip" }, [
      _vm._v(" 点击州块查看双轨状态 + 预计到期 "),
      _c("span", { staticClass: "fn-pt" }, [
        _vm._v(
          "Clique num estado para ver o status das duas trilhas + vencimento previsto"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }